import axios from 'axios'
import log from './logger'
import axiosRetry from 'axios-retry'

let httpClient = axios.create({
  baseURL: process.env.MEMORO_API_ROOT,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

axiosRetry(httpClient, { retries: 3 })

export function authenticate (username, password, projectID) {
  if (username.lastIndexOf(750, 0) === 0) {
    username = username.substring(3)
  }
  let requestPromise = httpClient.post('user_tokens', { 'auth': {
    'username': username,
    'password': password,
    'project_id': projectID
  }})

  // Cache Authorization header for future use
  requestPromise.then((response) => {
    httpClient.defaults.headers.common['Authorization'] = `Bearer ${response.data.jwt}`
  }).catch(e => {
    log.error(e)
  })

  return requestPromise
}

export function logout () {
  // Remove authorization headers
  httpClient.defaults.headers.common['Authorization'] = ''
}

export function createSession (browserInfo) {
  return httpClient.post('sessions', {session_data: {browser_info: browserInfo}})
}

export function currentUserInfo () {
  return httpClient.get('users/current')
}

export function getTasks () {
  return httpClient.get('tasks')
}

export function getWordList () {
  return httpClient.get('users/current/word_list')
}

export function userConsentGiven (birthyear, sex, education, handedness, computerFamiliarity) {
  return httpClient.patch('users/current', {consent_given_at: new Date(), birthyear: birthyear, sex: sex, education: education, handedness: handedness, computer_familiarity: computerFamiliarity})
}

export function userWasDisturbedOnTasks (tasks) {
  return httpClient.patch('users/current', {feedback: {disturbed_on_tasks: tasks}})
}

export function userWantsResultSummary () {
  return httpClient.patch('users/current', {wants_result_summary: true})
}

export function userBirthyearSexEducation (birthyear, sex, education) {
  return httpClient.patch('users/current', {birthyear: birthyear, sex: sex, education: education})
}

export function userHasRetakenTasks () {
  return httpClient.patch('users/current', {retaken_tasks: true})
}

export function createResult (data) {
  return httpClient.post('results', {result: data})
}

export function updateResult (resultID, resultData) {
  return httpClient.patch(`results/${resultID}`, {result: resultData})
}



// WEBPACK FOOTER //
// ./src/lib/kronolog-client.js